/**
 * templateLinkErrors.js — turns a rejection of Sun's template-link endpoints into the literal the user reads (story 224).
 * Sun's literals ARE the i18n keys (repo convention, `contrato-sun.md` §9.4), so a plain `t_(literal)` translates them.
 * A rejection without a literal (the 404 of an unknown workflow, a network failure) reads as the generic `Not allowed`.
 */

/**
 * @param {{status?: number, message?: string, data?: object}} thrown Error thrown by `Api_Functions`.
 * @returns {{status: number, error: string}} `error` is `''` when Sun sent no literal
 */
export const readTemplateLinkError = (thrown) => {
  const data = thrown && typeof thrown.data === 'object' && thrown.data !== null ? thrown.data : {}
  return {
    status: thrown && thrown.status ? thrown.status : 0,
    error: typeof data.error === 'string' ? data.error : ''
  }
}

/** @returns {string} the translated text of the rejection */
export const translateTemplateLinkError = (t_, thrown) => t_(readTemplateLinkError(thrown).error || 'Not allowed')

/**
 * @returns {boolean} whether Sun rejected with one of the story's own literals (`TEMPLATE_*`, contrato-sun.md §9.4, §10.4);
 * anything else a save carrying `templateUpdates` rejects with is an error of today's save (index not allowed, external job
 * without return...) and goes through the save's own error path
 */
export const isTemplateLinkError = (thrown) => readTemplateLinkError(thrown).error.startsWith('TEMPLATE_')
